const styles = () => ({
  page: {},
});

export default styles;
